module.exports = "\n.features-info {\n  margin-bottom: 20px;\n}\n\n.view-title {\n  margin-bottom: 10px;\n}\n\n.features-info:after {\n  content: \"\";\n  display: table;\n  clear: both;\n}\n\n.scene-menu-button {\n  display: none;\n}\n\n.scene-menu-icon-button {\n  display: inline-block;\n}\n\n@media (min-width: 765px) {\n  .scene-menu-button {\n    display: inline-block;\n  }\n  .scene-menu-icon-button {\n    display: none;\n  }\n}\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/features.component.css
// module id = ./src/app/components/features.component.css
// module chunks = main